<div class="card-inline" *ngIf="!readOnly">
    <button matTooltip="Adjuntar PDF" class="card-inline" (click)="fileInput.click()" mat-mini-fab>
    <mat-icon>cloud_upload</mat-icon>
    <input
      [style.display]="hideElement ? 'none' : 'inherit'"
      type="file"
      #fileInput
      (change)="uploadFile($event.target.files)"
    />
  </button>
</div>
<div class="card-inline" *ngIf="!readOnly">
    <h3>Adjuntar pdf</h3>
</div>
<mat-divider *ngIf="!readOnly"></mat-divider>
<br>
<br>
<div class="center" *ngIf="loading">
    <mat-spinner diameter="20"></mat-spinner>
</div>
<p *ngIf="readOnly && !loading && !loadFailed && files.length === 0">No hay archivos adjuntos.</p>
<table>
    <tr *ngFor="let file of files">
        <td *ngIf="selectable" class="attachment-checkbox">
            <mat-checkbox
                [checked]="selectedFileIds.indexOf(file.Id) !== -1"
                [aria-label]="file.Name"
                (change)="selectFile(file.Id, $event.checked)">
            </mat-checkbox>
        </td>
        <td style="min-width: 200px;" (click)="!selectable && download(file)">
            {{ file.Name }}
        </td>
        <td *ngIf="!readOnly">
            <mat-icon (click)="delete(file)">delete</mat-icon>
        </td>
    </tr>
</table>